import React from 'react';

const PersonalInfo = () => {
  return (
    <div className='wrap_main'>
      <div className='doc-contents'>
        <h1>개인정보 처리방침</h1>
        <h3>개인정보 처리에 관한 정보</h3>
        <h4>서문</h4>
        <p>
          Vincoholdinglp("당사", "당사의" 또는 "저희")는 이용자("귀하" 또는 "귀하의")의 개인정보를
          존중합니다. 본 개인정보 보호 고지("고지")는 당사의 웹사이트 named.net("웹사이트")과 관련하여
          귀하의 개인정보를 어떻게 수집, 사용, 공개 및 보호하는지 설명합니다. 당사는 귀하의 웹사이트 이용,
          웹사이트 회원가입, 직접 마케팅, 당사의 보호, 커뮤니케이션 및 귀하의 기기에 저장되는 HTTP 쿠키와
          관련하여 귀하의 개인정보를 처리합니다.
        </p>
        <h4 id='article1'>당사의 신원 및 연락처 정보</h4>
        <p>
          <strong>1.1.</strong> 당사는 귀하의 개인정보 컨트롤러(개인정보처리자)로서 Vincoholdinglp입니다.
        </p>
        <p>
          <strong>1.2.</strong> 당사는 개인정보 보호책임자를 임명하였으며, 귀하의 개인정보 처리 및 권리 행사와 관련된 모든
          사항은 이메일{' '}
          <strong>
            <a href='mailto:help@named.com'>help@named.com</a>
          </strong>
          으로 문의하실 수 있습니다.
        </p>
        <h4 id='article2'>웹사이트 이용 및 회원가입 관련 처리</h4>
        <p>
          <strong>2.1. 웹사이트 이용 시 처리 사양.</strong> 귀하가 웹사이트를 이용하는 경우, 당사는 웹사이트 이용 시 자동으로
          수집되는 이용 기록(IP 주소, Geo IP, 운영체제 데이터, 브라우저 유형 및 버전, 웹사이트 사용자 설정)을
          아래의 목적 B와 C를 위해 처리합니다.{' '}
        </p>
        <p>
          <strong>2.2. 회원가입 및 로그인 처리 사양.</strong> 귀하가 계정을 생성하고 웹사이트의 콘텐츠 및 회원가입 대상 기능을
          이용하는 동안, 당사는 목적 A, B, C를 위해 다음과 같은 데이터를 처리합니다:
        </p>
        <ul>
          <li>
            <strong>2.2.1.</strong> 계정 생성 시 제공한 사용자 이름 및 이메일 주소를 포함한 연락처 정보.
          </li>
          <li>
            <strong>2.2.2.</strong> 연령, 사진, 출신 국가, 가입일, 팔로우한 사용자, 팔로워 및 팔로잉 수 등 자발적으로
            제공한 추가 개인정보.
          </li>
          <li>
            <strong>2.2.3.</strong> 웹사이트 성능 추적 및 기술적 결함 보고를 위한 가명화된 식별자, 그리고 귀하를 보호하기
            위해 도입된 기타 가명화된 식별자.
          </li>
          <li>
            <strong>2.2.4.</strong> 서비스 이용 정보(예: 개인 설정, 예측 기능 이용 내역 및 통계, 쿠폰 사용 정보, 전체 예측
            통계, 투자 수익률(ROI), 예측 콘텐츠에 대한 ‘좋아요’ 등)를 처리합니다.
          </li>
        </ul>
        <p>
          <strong>2.3. 처리 목적.</strong> 당사는 다음 목적에 필요한 범위 내에서 귀하의 개인정보를 처리합니다:
        </p>
        <ul>
          <li>
            <strong>• 목적 A:</strong> 귀하와 당사 간의 계약 이행 또는 웹사이트 회원가입 및 로그인과 관련하여 계약 체결 전
            단계의 조치를 취하기 위함입니다.
          </li>
          <li>
            <strong>• 목적 B:</strong> 웹사이트의 기술적 운영, 즉 웹사이트의 적절하고 원활한 기능 보장, 보고된 기술적
            오류의 해결 및 그에 따른 웹사이트 최적화(향후 오류 방지)를 위함입니다. 당사는 이 목적을 위해
            귀하의 개인정보를 처리하는 것이 가능한지 평가하고, 귀하의 권리 보호와 당사의 이익을
            평가하는 비례성 테스트를 수행했습니다. 당사가 처리하는 대부분의 개인정보가 다른 목적을
            위해서도 사용 가능하다는 점, 가명 식별자를 사용한다는 점, 결함 제거가 사용자에게도 이익이
            된다는 점, 최적화가 모든 사용자에게 이익이 된다는 점에 비추어 볼 때, 귀하의 이익이나
            기본권이 당사의 정당한 이익보다 우선한다고 판단되지 않는다는 결론을 내렸습니다.
          </li>
          <li>
            <strong>• 목적 C:</strong> 특히 세무, 회계 및 광고 규제 분야의 법적 의무를 준수하기 위함입니다.
          </li>
        </ul>
        <p>
          <strong>2.4. 법적 근거.</strong> 각 목적별 개인정보 처리의 법적 근거는 다음과 같습니다:
        </p>
        <ul>
          <li>
            <strong>2.4.1.</strong> 목적 A의 경우, 법적 근거는 규정(EU) 2016/679(일반 데이터 보호 규정, "규정") 제6조 제1
            항 (b)호에 따른 계약 이행 또는 계약 체결 전 조치입니다.
          </li>
          <li>
            <strong>2.4.2.</strong> 목적 B의 경우, 법적 근거는 웹사이트의 기술적 운영 보장이라는 규정 제6조 제1항 (f)호에
            따른 당사의 정당한 이익입니다.
          </li>
          <li>
            <strong>2.4.3.</strong> 목적 C의 경우, 법적 근거는 규정 제6조 제1항 (c)호에 따른 법적 의무 준수입니다.
          </li>
        </ul>
        <p>
          <strong>2.5. 보유 기간.</strong> 귀하의 개인정보는 다음과 같이 처리됩니다:
        </p>
        <ul>
          <strong>• 목적 A:</strong> 계약 종료 후 최대 3년까지.
          <strong>• 목적 B:</strong> 계정이 있는 경우 계약 기간 동안, 계정이 없는 경우 웹사이트 이용 후 1개월 동안.
          <strong>• 목적 C:</strong> 관련 법령에 따른 법적 의무 준수에 필요한 기간 동안.
        </ul>
        <p>
          <strong>2.6. 기타 수혜자.</strong> 호스팅 및 소프트웨어 개발 서비스를 제공하는 자를 포함하여 당사를 위해 기술적
          활동을 수행하는 자 및 당사 그룹의 다른 회사("당사 그룹")가 귀하의 개인정보 수혜자가 될 수 있습니다.
          귀하의 프로필은 공개로 설정되어 있으므로 프로필 내 특정 정보에 대해서는 모든 인터넷 이용자가
          수혜자가 될 수 있습니다. (사용자는 프로필을 비공개로 설정하여 예측을 숨길 수 있는 옵션이 있습니다.)
        </p>
        <p>
          <strong>2.7. 귀하의 권리.</strong> 귀하는 규정에 명시된 조건에 따라 목적에 따라 당사에 개인정보 접속, 정정, 삭제, 처리
          제한 및 데이터 이식권을 요청할 권리가 있습니다. 당사는 이러한 요청을 이행하기 전에 귀하의 신원
          확인을 요청할 수 있음을 유의하시기 바랍니다:
        </p>
        <ul>
          <li>
            <strong>2.7.1.</strong> 귀하의 개인정보 처리가 규정을 위반했거나 위반하고 있다고 의심되는 경우, 귀하는
            귀하의 상거소, 직장 또는 위반 행위가 발생한 장소의 EU 회원국 감독 기관에 불만을 제기할
            권리가 있습니다.
          </li>
          <li>
            <strong>2.7.2.</strong> 귀하는 언제든지 목적 B를 위한 개인정보 처리에 반대할 권리가 있습니다. 반대하는 경우,
            당사는 귀하의 이익이나 권리보다 우선하는 강력하고 정당한 근거를 입증하거나 법적 청구의
            제기, 행사, 방어에 필요한 경우가 아닌 한 해당 정보를 더 이상 처리하지 않습니다.
          </li>
          <li>
            <strong>2.7.3.</strong> 귀하는 개인정보 제공 의무가 없습니다. 그러나 개인정보 제공은 목적 A(계약 체결 및
            이행)를 위한 필수 요건이며, 정보를 제공하지 않을 경우 계약 체결이 불가능하여 회원 전용
            기능이나 구매를 이용하지 못할 수 있습니다.
          </li>
        </ul>
        <h4 id='article3'>마케팅 관련 처리</h4>
        <p>
          <strong>3.1. 처리 사양.</strong> 귀하의 동의 하에 당사는 다음을 처리합니다:
        </p>
        <ul>
          <li>
            <strong>3.1.1.</strong> 위 2.2조에 설명된 개인정보.
          </li>
          <li>
            <strong>3.1.2.</strong> 귀하를 보호하기 위해 도입된 가명화된 식별자.
          </li>
          <li>
            <strong>3.1.3.</strong> 웹사이트 이용 정보(IP 주소, Geo IP, 분석 정보) 및 기기 정보(운영체제, 브라우저 버전 등)
            를 활용하여 당사, 당사 그룹 또는 제3자의 광고성 정보(마케팅 오퍼)를 전송하거나 마케팅
            프로파일링을 포함한 마케팅 활동을 수행합니다. 이 처리는 귀하의 명시적 동의에 근거하며,
            귀하는 언제든지 동의를 철회할 권리가 있습니다.
          </li>
        </ul>
        <p>
          <strong>3.2. 목적 D.</strong> 처리 목적은 광고성 정보를 전송하고 마케팅 프로파일링을 포함한 기타 마케팅 활동을
          수행하는 것입니다.
        </p>
        <p>
          <strong>3.3. 법적 근거.</strong> 법적 근거는 규정 제6조 제1항 (a)호에 따른 귀하의 동의입니다.
        </p>
        <p>
          <strong>3.4. 보유 기간.</strong> 당사는 동의를 받은 날로부터 4년 동안 정보를 처리(보관)하며, 동의를 철회하는 즉시
          처리가 중단됩니다.
        </p>
        <p>
          <strong>3.5. 기타 수혜자.</strong> 마케팅 및 광고 서비스 제공자, 웹사이트 운영자, 당사 그룹 회사(데이터 처리자) 및
          주요 소셜 네트워크(Facebook, Twitter, LinkedIn 등)가 수혜자가 될 수 있습니다.
        </p>
        <p>
          <strong>3.6. 귀하의 권리.</strong> 규정에 따라 귀하는 접속권, 정정권, 삭제권, 처리 제한권 및 데이터 이식권을 가집니다:
        </p>
        <ul>
          <li>
            <strong>3.6.1</strong> 귀하는 언제든지 제공한 동의를 철회할 권리가 있습니다. 이는 철회 전 처리의 적법성에는
            영향을 미치지 않습니다. 광고성 정보 내의 하이퍼링크를 클릭하거나 당사 연락처 이메일로
            메시지를 보내 철회할 수 있습니다.
          </li>
          <li>
            <strong>3.6.2.</strong> 규정 위반이 의심되는 경우 EU 회원국 감독 기관에 불만을 제기할 권리가 있습니다.
          </li>
          <li>
            <strong>3.6.3.</strong> 귀하는 개인정보를 제공할 의무가 없으며, 이는 법적·계약적 요건이 아닙니다.
          </li>
        </ul>
        <h4 id='article4'>커뮤니케이션 관련 처리</h4>
        <p>
          <strong>4.1. 처리 사양.</strong> 문의 양식이나 직접적인 연락을 통해 당사에 연락하는 경우, 귀하의 동의를 바탕으로
          이메일, 성함 및 대화 내용을 처리합니다.
        </p>
        <p>
          <strong>4.2. 목적 E.</strong> 귀하와 당사 간의 소통 및 해당 소통 기록 유지가 목적입니다.
        </p>
        <p>
          <strong>4.3. 법적 근거.</strong> 법적 근거는 규정 제6조 제1항 (a)호에 따른 귀하의 동의입니다.
        </p>
        <p>
          <strong>4.4. 보유 기간.</strong> 동의를 준 해의 다음 두 번째 역년(Calendar year) 말까지 보관됩니다.
        </p>
        <p>
          <strong>4.5. 기타 수혜자.</strong> 기술/조직 활동 제공자, 당사 그룹 회사, 그리고 법령에 따라 요구되는 경우 공공기관이
          수혜자가 될 수 있습니다.
        </p>
        <p>
          <strong>4.6. 귀하의 권리.</strong> 규정에 따른 접속, 정정, 삭제, 처리 제한, 데이터 이식권을 가집니다. (이메일을 통해
          언제든지 동의 철회 가능)
        </p>
        <h4 id='article5'>HTTP 쿠키 설치 관련 처리</h4>
        <p>
          <strong>5.1. 처리 사양.</strong> 웹사이트의 쿠키 바(Cookie bar)를 통해 귀하의 기기에 HTTP 쿠키를 저장하는 것에
          동의할 수 있습니다.{' '}
        </p>
        <p>
          <strong>5.2. 처리 목적.</strong> 쿠키의 성격에 따라 다르며, 자세한 정보는 쿠키 바 내에서 제공됩니다.
        </p>
        <p>
          <strong>5.3. 법적 근거.</strong> 규정 제6조에 따른 법적 근거는 쿠키 바에 명시되어 있습니다.
        </p>
        <p>
          <strong>5.4. 보유 기간.</strong> 쿠키별로 다르며 쿠키 바 또는 별도 문서에 게시됩니다.
        </p>
        <p>
          <strong>5.5. 기타 수혜자.</strong> 쿠키 성격에 따라 다르며 쿠키 바 등을 통해 고지됩니다.
        </p>
        <p>
          <strong>5.6. 귀하의 권리.</strong> 규정에 따른 기본 권리를 가지며, 쿠키 바를 통해 언제든지 동의를 철회할 수 있습니다.
        </p>
        <h4 id='article6'>정보 보안</h4>
        <p>
          <strong>6.1.</strong> 당사는 관련 법령에 따라 귀하의 개인정보를 보호하기 위해 관리적, 기술적, 물리적 보안 조치를
          사용합니다.
        </p>
        <h4 id='article7'>추가 정보</h4>
        <p>
          <strong>7.1. 자동화된 의사결정.</strong> 당사는 규정 제22조에 따른 자동화된 개인별 의사결정을 수행하지 않습니다.
        </p>
        <p>
          <strong>7.2. 제3자 활동.</strong> 당사는 귀하가 정보를 공개한 제3자의 행위에 대해 책임을 지지 않으며, 제3자의 오퍼
          발송을 통제할 권한이 없습니다. 제3자의 연락을 중단하고 싶다면 해당 제3자에게 직접 문의하십시오.
        </p>
        <h4 id='article8'>EU 외부로의 개인정보 이전</h4>
        <p>
          <strong>8.1.</strong> 당사는 귀하의 개인정보를 제3국(비EU 국가)이나 국제기구로 의도적으로 이전할 계획은 없습니다.
          다만, 일부 파트너나 수혜자가 비EU 국가에 위치하거나 EU 외부 서버에 데이터를 저장할 수 있습니다. 이
          경우 규정에 따른 "제3국으로의 데이터 이전"이 발생할 수 있으며, 당사는 표준 개인정보 보호정책 및
          규정 제46조에 따른 적절한 안전장치를 통해 정보가 보호되도록 보장할 것입니다.
        </p>
        <p>
          <strong>8.2.</strong> 당사는 본 고지를 수시로 수정하거나 업데이트할 권리를 보유하며, 최신 버전은 항상 플랫폼에
          게시합니다.
        </p>
        <p>
          <strong>8.3.</strong> 귀하의 권리를 인지할 수 있도록 본 고지를 정기적으로 확인하시기 바랍니다.
        </p>

        <div className='doc-footer'>
          <p>2025년 1월 9일, 영국에서</p>
          <p>Vincoholdinglp</p>
        </div>
      </div>
    </div>
  );
};

export default PersonalInfo;
